import { FunctionComponent } from 'react';
import { PortalContainer } from '../../components/PortalContainer';
import Grid from '@mui/material/Grid';

// TODO: https://tempuslabs.atlassian.net/browse/NP-2095
const TempusPro: FunctionComponent = () => {
  return (
    <PortalContainer>
      <Grid container direction="column" justifyContent="center" alignItems="center">
        Tempus PRO Component
      </Grid>
    </PortalContainer>
  );
};

export default TempusPro;
